import React, { ReactNode } from 'react';
import { Provider } from 'react-redux';
import Head from './components/Head';
import Footer from './components/Footer';
import { store } from './store';
import './App.less';

interface IProps {
  children: ReactNode;
}

const App = (props: IProps) => {
  const { children } = props;
  return (
    <Provider store={store}>
      <div className="app-container">
        {/* 头部 */}
        <Head />
        <div className="page-content">
          {/* 页面内容 */}
          {children}
        </div>
        {/* 底部 */}
        <Footer />
      </div>
    </Provider>
  );
};

export default App;
